import React from "react";
import { Link, withRouter } from "react-router-dom";
import { useQuery, useMutation } from "@apollo/client";
import { Breadcrumb, Header, Loader, Button, Icon } from "semantic-ui-react";
import {
  UPDATE_STUDENT,
  GET_STUDENT_FIELDS,
  GET_EDIT_STUDENT,
} from "../GraphQL";
import StudentQuestionsForm from "../components/StudentQuestionsForm";

const StudentQuestionsPage = ({ match, history }) => {
  const { error, loading, data } = useQuery(GET_EDIT_STUDENT, {
    variables: { id: match.params.id },
  });
  const [updateStudent] = useMutation(UPDATE_STUDENT);

  if (loading) {
    return <Loader active />;
  }
  if (error) {
    throw error;
  }
  const student = data.getStudent;
  return (
    <div>
      <Breadcrumb size="tiny">
        <Breadcrumb.Section>
          <Link to="/">Home</Link>
        </Breadcrumb.Section>
        <Breadcrumb.Divider icon="right angle" />
        <Breadcrumb.Section>
          <Link to={`/students/${student.id}`}>{student.name}</Link>
        </Breadcrumb.Section>
        <Breadcrumb.Divider icon="right angle" />
        <Breadcrumb.Section active>Report Questions</Breadcrumb.Section>
      </Breadcrumb>
      <Button basic floated="right" as={Link} to="/settings/fields">
        <Button.Content>
          <Icon name="question circle" /> Question Bank
        </Button.Content>
      </Button>

      <Header as="h3">
        Report Questions
        <Header.Subheader>
          Select questions from your Question Bank to appear on the report for{" "}
          {student.name}. Drag questions to reorder the appearance on the
          report.
        </Header.Subheader>
      </Header>
      <StudentQuestionsForm
        student={student}
        onSubmit={(input) => {
          console.log(input);
          updateStudent({
            variables: { id: match.params.id, input },
            refetchQueries: [
              {
                query: GET_STUDENT_FIELDS,
                variables: { studentId: match.params.id },
              },
            ],
          });
          history.push(`/students/${match.params.id}`);
        }}
        onCancel={() => history.push(`/students/${student.id}`)}
      />
    </div>
  );
};

export default withRouter(StudentQuestionsPage);
